import styled from 'styled-components';

export const AddStaffFormContainer = styled.div({
  marginTop: 24,
});
